export const isReportSent = (customData) => {
  return customData?.find(({ name, value }) => name === 'report_sent' && (value === 'true' || value === true));
};
